import fastdom from 'fastdom'
if(document.body.contains(document.querySelector('.articleToolbar'))) {
    // Articletool bar exist
    
    const checkToolbarVisibility = () => {
        var toolbarElement = document.querySelector('.articleToolbar'),
        articleNavElement = toolbarElement.querySelector('.articleNav')

        var lastYPosition = 0,
            headerHeight = 0,
            navBottom = 0,
            isFixedHeader = 0,
            header = document.querySelector('.header')

        fastdom.measure(function () {
          lastYPosition = window.pageYOffset
          headerHeight = header.offsetHeight
          isFixedHeader = parseInt(window.getComputedStyle(document.body).getPropertyValue('--use-sticky-header') || 0)

          if (articleNavElement) {
            navBottom = articleNavElement.offsetTop + articleNavElement.clientHeight - headerHeight
          }
        })

        fastdom.mutate(function () {
          toolbarElement.style.top = isFixedHeader ? headerHeight + 'px' : null

          if (articleNavElement) {
            if (lastYPosition > 150 && articleNavElement && lastYPosition < navBottom) {
              toolbarElement.classList.add('is-visible')
            } else {
              toolbarElement.classList.remove('is-visible')
            }
          } else {
            if (lastYPosition > 150) {
              toolbarElement.classList.add('is-visible')
            } else {
              toolbarElement.classList.remove('is-visible')
            }
          }
        })
    }

    window.addEventListener('scroll', checkToolbarVisibility)
}